import React from 'react';
import { Toaster } from 'react-hot-toast';
import { toastOptions } from '../lib/toast';

export function AppToaster() {
  return (
    <Toaster
      position={toastOptions.position}
      toastOptions={{
        duration: toastOptions.duration,
        style: toastOptions.style,
        success: toastOptions.success,
        error: toastOptions.error,
      }}
      containerStyle={{
        top: 24,
      }}
      gutter={10}
    />
  );
}
